export const CHATWOOT_DELETE_CONVERSATION_PERMISSION = 'eliminar_conversaciones';
export const CHATWOOT_ASSIGN_AGENT_PERMISSION = 'asignar_agente_conversacion';
export const CHATWOOT_ASSIGNMENT_TRACE_PERMISSION = 'ver_trazabilidad_asignaciones';

function isChatwootAdminUsername(user) {
  return String(user?.username || '').trim().toLowerCase() === 'admin';
}

export function canDeleteChatwootConversation(user) {
  if (!user) return false;
  if (isChatwootAdminUsername(user)) return true;
  const perms = Array.isArray(user.permissions) ? user.permissions : [];
  return perms.includes(CHATWOOT_DELETE_CONVERSATION_PERMISSION);
}

export function canAssignChatwootAgent(user) {
  if (!user) return false;
  if (isChatwootAdminUsername(user)) return true;
  const perms = Array.isArray(user.permissions) ? user.permissions : [];
  return perms.includes(CHATWOOT_ASSIGN_AGENT_PERMISSION);
}

export function parseAgentDisplayLabel(label) {
  const raw = String(label || '').trim();
  if (!raw) return { username: '', chatwootName: '', full: '' };
  const match = raw.match(/^(.+?)\s*\(([^)]+)\)\s*$/);
  if (match) {
    return {
      username: match[1].trim(),
      chatwootName: match[2].trim(),
      full: raw
    };
  }
  return { username: raw, chatwootName: '', full: raw };
}

export function getAgentDisplayInitials(name) {
  const { username, chatwootName, full } = parseAgentDisplayLabel(name);
  const source = String(chatwootName || username || full || '').trim();
  if (!source) return 'AG';
  const normalized = source.replace(/[_]+/g, ' ').replace(/[()]/g, ' ').trim();
  const parts = normalized.split(/\s+/).filter((p) => /[A-Za-zÁÉÍÓÚáéíóúÑñ]/.test(p));
  if (parts.length >= 2) {
    const a = parts[0].match(/[A-Za-zÁÉÍÓÚáéíóúÑñ]/)?.[0] || '';
    const b = parts[1].match(/[A-Za-zÁÉÍÓÚáéíóúÑñ]/)?.[0] || '';
    return `${a}${b}`.toUpperCase() || 'AG';
  }
  const letters = normalized.replace(/[^A-Za-zÁÉÍÓÚáéíóúÑñ]/g, '');
  return (letters.slice(0, 2) || 'AG').toUpperCase();
}
